import React, { useState } from "react";
// import values from "../../../../values";

import { Container } from "react-bootstrap";
import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../components";
import values from "../../../../values";
import { Components } from "./components";
import "./index.scss";
import Context from "../../../../context";
import { useTranslation } from "react-i18next";

type Props = {
  rqData: any;
  showModalData: any;
};

const CompanyFactors = (props: Props) => {
  const { requestDebt, setRequestRequestDebt } = React.useContext(
    Context.CompanyFactorScreen
  );

  const { t } = useTranslation();
  // const {status: showModalStatus, data: showModalData} = props.showModalData;

  return (
    <section id="transactions-screen">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {/* <Components.Filter />
          <Components.Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader
              headers={values.tableHeaders.COMPANY_FACTOR_LIST.map((item) =>
                t(item)
              )}
            />
            {props.rqData?.status === "loading" ? (
              <TableLoading />
            ) : (
              <Components.Body data={props.rqData} />
            )}
          </table>
        </div>
      </Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestDebt?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestRequestDebt({
                  ...requestDebt,
                  page: page,
                })
              }
            />
          </div>
        )}
    </section>
  );
};

export default CompanyFactors;
